import { useCallback } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { createSearchParams, useLocation } from "react-router-dom";
import { Pagination } from "@mui/material";
import TopBarProgress from "react-topbar-progress-indicator";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  deleteInspirationTag,
  getInspirationTag,
} from "../../../../actions/inspirationTags";
import CustomeTableBtn from "../../../../components/custome-table-button/CustomeTableBtn";

const InspirationsTags = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Local State
  const [isMount, setisMount] = useState(false);
  const [loading, setloading] = useState(true);
  const [Data, setData] = useState([]);
  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });

  // Api calls for get Order
  const getInspirationTags = useCallback(
    async (pageNo) => {
      const res = await dispatch(getInspirationTag(pageNo));
      setData(res?.tags);
      setpagination({
        ...res?.pagination,
      });
      setloading(false);
    },
    [dispatch]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get("page")) || 1;
    if (page !== pagination.currentPage) {
      setpagination(prev => ({ ...prev, currentPage: page }));
    }
  }, [location.search]);

  useEffect(() => {

    var isSubscribe = true;
    if (isSubscribe) {
      var timer = setTimeout(() => {
        getInspirationTags(pagination.currentPage);
      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, isMount]);

  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({ page: value })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  //Delete Category
  const deleteInspirationTags = async (id) => {
    setloading(true);
    const res = await dispatch(deleteInspirationTag(id));
    if (res) {
      setdeleteConfirm({
        open: false,
        id: null,
      });
      setisMount(!isMount);
      setloading(false);
    }
  };
  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div className="process-orders-table">
            <table className="mt-5">
              <thead>
                <tr>
                  <th>Sn#</th>
                  <th>Name</th>
                  <th>Image</th>
                  <th>Created At</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Data?.length ? (
                  <>
                    {Data?.map((item, i) => (
                      <tr key={item?._id}>
                        <td
                          className="order-item-number"
                          onClick={() =>
                            navigate(`/admin/inspiration-tag?id=${item._id}`)
                          }
                        >
                          {i + 1}
                        </td>
                        <td>{item.name}</td>

                        <td>
                          <img
                            src={item.imageUrl}
                            height="50px"
                            width="50px"
                            alt="item"
                          />
                        </td>

                        <td>{moment(item?.createdAt).format("l")}</td>
                        <td>
                          <CustomeTableBtn
                            color="secondary"
                            width={"100px"}
                            className={"mr-2"}
                            onClick={() =>
                              navigate(`/admin/inspiration-tag?id=${item._id}`)
                            }
                          >
                            Edit
                          </CustomeTableBtn>

                          <CustomeTableBtn
                            color="danger"
                            width={"100px"}
                            onClick={() =>
                              setdeleteConfirm({
                                open: true,
                                id: item?._id,
                              })
                            }
                          >
                            Delete
                          </CustomeTableBtn>

                          {deleteConfirm.open && (
                            <SweetAlert
                              warning
                              showCancel
                              confirmBtnText="Yes, delete it!"
                              confirmBtnBsStyle="danger"
                              title="Are you sure?"
                              onConfirm={(e) => {
                                deleteInspirationTags(deleteConfirm.id);
                              }}
                              onCancel={() =>
                                setdeleteConfirm({
                                  open: false,
                                  id: null,
                                })
                              }
                              focusCancelBtn
                            >
                              Are you sure you want to delete?
                            </SweetAlert>
                          )}
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <>
                    <tr>
                      <td colSpan={9} className=" text-center">
                        {" "}
                        No Record Found
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className=" d-flex justify-content-center my-4">
            <Pagination
              count={pagination.totalPages}
              page={pagination.currentPage}
              onChange={handleChange}
            />
          </div>
        </>
      )}
    </>
  );
};

export default InspirationsTags;
